import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class RegistrationService {
  public abstract confirmRegistrationEmail(emailGuid: string): Observable<any>;

  public abstract getActivationParentState(): string;
}
